import React from 'react';
import {
  Grid,
  Typography,
  FormControlLabel,
  Radio,
  FormHelperText,
} from '@material-ui/core';
import { RadioGroup } from 'formik-material-ui';
import { Field, useFormikContext, ErrorMessage } from 'formik';

import { IExpandedMailingRule } from 'interfaces/MailingRule';

import { IMailingRuleSubformProps } from '../../interfaces';
import { RootState } from 'store';
import { useSelector } from 'react-redux';

const Form: React.FC<IMailingRuleSubformProps> = ({
  isEditable,
}: IMailingRuleSubformProps) => {
  const { values } = useFormikContext<IExpandedMailingRule>();

  const {
    list: { mailingRuleEpsDebtDistributionTypes },
  } = useSelector((state: RootState) => state.parameters);

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="flex-start"
    >
      <Grid item xs={12}>
        <Typography variant="h6">Distribuição da dívida entre EPSs</Typography>
      </Grid>
      <Grid
        data-cy="rules-execution-form__radio-buttons--debts-distribution"
        item
        xs={12}
      >
        <Field component={RadioGroup} name="debtsDistribution">
          <FormHelperText error>
            <ErrorMessage name="debtsDistribution" />
          </FormHelperText>
          {mailingRuleEpsDebtDistributionTypes.map((debtsDistribution) =>
            debtsDistribution.value !== 'CUSTOMER_AMOUNT' ||
            values.aggregationType === 'CUSTOMER' ? (
              <FormControlLabel
                key={debtsDistribution.value}
                value={debtsDistribution.value}
                control={<Radio />}
                label={debtsDistribution.label}
                disabled={!isEditable}
              />
            ) : null,
          )}
        </Field>
      </Grid>
    </Grid>
  );
};

export default Form;
